import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import { CookieBanner } from "./components/site/CookieBanner";
import Home from "./pages/Home";
import Secteurs from "./pages/Secteurs";
import Metiers from "./pages/Metiers";
import Questionnaire from "./pages/Questionnaire";
import Resultat from "./pages/Resultat";
import Forfaits from "./pages/Forfaits";
import ForfaitDetail from "./pages/ForfaitDetail";
import NonIncorpores from "./pages/NonIncorpores";
import Incorpores from "./pages/Incorpores";
import PlansEducatifs from "./pages/PlansEducatifs";
import RessourcesFaq from "./pages/RessourcesFaq";
import Consultation from "./pages/Consultation";
import Pourquoi from "./pages/Pourquoi";
import Confidentialite from "./pages/Confidentialite";
import PlanCollectif from "./pages/PlanCollectif";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/admin/AdminLogin";
import Admin from "./pages/admin/Admin";

const TITLES = {
  "/": "Accueil", "/secteurs": "Votre secteur", "/forfaits": "Nos solutions", "/travailleurs-non-incorpores": "Travailleurs non incorporés",
  "/incorpores": "Entreprises incorporées", "/plans-educatifs": "Plans éducatifs", "/plan-collectif": "Plan collectif", "/ressources-faq": "Ressources et FAQ",
  "/consultation": "Consultation gratuite", "/pourquoi-struktiv": "Pourquoi STRUKTIV?", "/politique-de-confidentialite": "Politique de confidentialité",
};

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    document.title = `${TITLES[pathname] || "STRUKTIV"} | STRUKTIV — La finance simplifiée`;
    if (hash) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 150);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

const SiteLayout = () => (
  <div className="relative isolate flex min-h-screen flex-col">
    <div className="site-bg" style={{ backgroundImage: "url(/img/pont2_duo.jpg)" }} aria-hidden="true" data-testid="site-fixed-background" />
    <Header />
    <main className="flex-1"><Outlet /></main>
    <Footer />
    <CookieBanner />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Toaster position="top-center" richColors />
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/secteurs" element={<Secteurs />} />
          <Route path="/secteurs/:sectorSlug" element={<Metiers />} />
          <Route path="/questionnaire/:sectorSlug/:jobSlug" element={<Questionnaire />} />
          <Route path="/resultat" element={<Resultat />} />
          <Route path="/forfaits" element={<Forfaits />} />
          <Route path="/forfaits/:slug" element={<ForfaitDetail />} />
          <Route path="/travailleurs-non-incorpores" element={<NonIncorpores />} />
          <Route path="/incorpores" element={<Incorpores />} />
          <Route path="/plans-educatifs" element={<PlansEducatifs />} />
          <Route path="/plan-collectif" element={<PlanCollectif />} />
          <Route path="/ressources-faq" element={<RessourcesFaq />} />
          <Route path="/consultation" element={<Consultation />} />
          <Route path="/pourquoi-struktiv" element={<Pourquoi />} />
          <Route path="/politique-de-confidentialite" element={<Confidentialite />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/admin/connexion" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
